export class Labels {
  static PATIENT_CARD = {
    NAME: 'Nome: ',
    CODE: 'Codigo: ',
    URGENT: 'Urgente',
    NOT_STARTED: { key: 'NOT_STARTED', label: 'Não iniciado' },
    STARTED: { key: 'STARTED', label: 'Em andamento' },
    FINISHED: { key: 'FINISHED', label: 'Finalizado' },
    EXTERNAL_PATIENT_DATA: '<Dados no LIS>',
  };

  static BUG_REPORT = {
    TITLE: 'Reportar um erro ou enviar feedback',
    DESCRIPTION: 'Descreva o erro ou o feedback',
    SUBMIT: 'Enviar',
    WHERE_ERROR: 'Onde ocorreu o erro?',
    IA: 'IA',
    PLATFORM: 'Plataforma',
    OTHER: 'Outro',
    ANALYSIS: 'Análise',
    HEATMAP: 'Mapa de Calor',
    DIGITAL_MICROSCOPE: 'Microscópio Digital',
    REPORT: 'Laudo',
    DISCUSSION: 'Discussão',
    DIGITAL_DATABASE: 'Banco de imagens',
    INCORRECT_RESULT: 'Resultado incorreto',
    EXECUTION: 'Execução',
    ERROR_DESCRIPTION_REQUIRED: 'Descrição do erro é obrigatória',
    CANCEL: 'Cancelar',
    SUCCESS: 'Erro ou feedback reportado com sucesso',
    ERROR: 'Falha ao reportar o erro ou feedback',
  };

  static INITIAL_TOOL_PANEL = {
    MY_EXAMS: 'Meus exames',
    DISCUSSIONS: 'Novas mensagens',
    DATABASE: 'Banco de imagens',
    REGISTER_CASE: 'Cadastro de caso',
    USER_MANAGEMENT: 'Gerenciamento de usuários',
    INTEGRATION_LOG: 'Log de integração',
    MONITOR_EXAMS: 'Monitorar casos',
  };

  static CONTROLS = {
    SHARE_IMAGE: 'Compartilhar caso',
    UNSHARE_IMAGE: 'Cancelar compartilhamento',
    ADD_TO_DATABASE: 'Adicionar ao banco de imagens',
    IMAGE_MANIPULATION: 'Manipular imagem',
    SPLIT: 'Dividir tela',
    CLOSE_SPLIT: 'Fechar',
    DRAG_IMAGE: 'Arraste a imagem desejada',
    ZOOMIN: 'Ampliar',
    ZOOMOUT: 'Diminuir',
    MENU: 'Menu',
    RESTORE: 'Restaurar zoom',
    FULLSCREEN: 'Tela cheia',
    EXIT_FULLSCREEN: 'Restaurar',
    SEPARATE_WINDOW: 'Abrir em janela separada',
    PAN: 'Pan',
    DRAW: 'Desenhar',
    DRAW_SQUARE: 'Desenhar quadrado',
    PHOTO: 'Tirar foto',
    MEASURE: 'Medir',
    REVERT: 'Reverter',
    FOV: 'FOV',
    INSERT_DESIRED_AREA: 'Insira a área desejada em mm2',
    DISABLE_FOV: 'Desabilitar FOV',
    CHOOSECOLOR: 'Escolher cor',
    FORWARD: 'Próximo exame',
    BACK: 'Exame anterior',
    EXAMS: 'Exames',
    LIST: 'Lista',
    SHARE_IMAGE_SUCCESS_TITLE: 'Compartilhamento bem sucedido',
    SHARE_IMAGE_SUCCESS_TEXT: 'Use a URL abaixo para compartilhar o caso.',
    ALLOW_BARCODE: 'Permitir acesso ao código de barras',
    ALLOW_BARCODE_SUCCESS_TITLE: 'Permissão de código de barras atualizada',
    UNSHARE_IMAGE_SUCCESS_TITLE: 'Compartilhamento cancelado',
    ACTIVE: 'Ativo',
    COUNT: 'Contagem',
    TURN_VISIBLE: 'Tornar visivel',
    TURN_INVISIBLE: 'Tornar invisivel',
    DELETE: 'Deletar',
    INSERT_NAME: 'Insira o nome',
    REMOVE: 'Remover',
    ADD_COUNTING: 'Adicionar contagem',
    COUNTING: 'Contagem manual',
    CLEAR_COUNTING: 'Limpar contagem',
    ROTATION: 'Rotação',
    BRIGHTNESS: 'Brilho',
    CONTRAST: 'Contraste',
    GAMMA: 'Gamma',
    RESET: 'Reset',
  };

  static DASHBOARD = {
    USE_LANDSCAPE: 'Por favor use em modo paisagem ',
    FULL_SCREEN_MODE: 'Ou use o modo tela cheia',
    EXAM_NOT_ALLOWED: 'Acesso ao exame não permitido',
  };

  static DASHBOARD_TOOL_PANEL = {
    PRONTUARY: 'Prontuario',
    IA: 'IA',
    REPORT: 'Laudo',
    DISCUSSION: 'Discussão',
    ANNOTATION: 'Anotações',
    SHOW_TOOLS: 'Ferramentas',
    HIDE_TOOLS: 'Ocultar',
  };

  static EXAM_INFO = {
    CASE_ID: 'ID de caso',
    REGION: 'Região de análise',
    PATIENT_CODE: 'Código',
    PATIENT_SEX: 'Sexo',
    PATIENT_NAME: 'Nome',
    PATIENT_AGE: 'Idade',
    PATIENT_BIRTHDAY: 'Data de nascimento',
    REGION_NAMES: {
      lung: 'Pulmão',
      prostate: 'Prostata',
      lymphnode: 'Linfonodo',
      unknown: 'Não especificado',
    },
  };

  static VIEWER = {
    SLIDELIST_TITLE: 'Lâminas',
    HEATMAP: 'Mapa de calor',
    DETECT_TUMOR: 'Detectar tumor',
    SLIDES: 'Imagens',
    TOOLS: 'Ferramentas',
    LOADING_IMAGE: 'Carregando imagem...',
    LOADING_MAP: 'Carregando mapa...',
    ERROR_FETCHING_MAP: 'Erro carregando mapa',
    ERROR_FETCHING_IMAGE: 'Error carregando imagem',
    CLOSE: 'Fechar',
    INFO: 'Informações',
    END_OF_LIST: 'Atingiu o fim da lista',
    BEGIN_OF_LIST: 'Atingiu o início da lista',
    IMAGE_EXPIRED:
      'Esta imagem expirou e foi removida dos nossos servidores. É necessária uma nova solicitação ao fornecedor para recuperá-la.',
  };

  static REPORT_TOOLS = {
    CAPTURE: 'Capturar',
    LOAD: 'Templates',
    SELECT_TEMPLATE: 'Templates disponiveis',
    REPORT_PLACEHOLDER: 'Digite aqui...',
    SAVE: 'Salvar',
    SUCCESS: 'Relatório salvo',
    SUCCESS_RELEASE: 'Exame liberado',
    SUCCESS_REOPEN: 'Exame reaberto',
    RELEASE_EXAM: 'Liberar exame',
    REOPEN_EXAM: 'Reabrir exame',
    GENERATE_PDF: 'Gerar pdf',
    DOWNLOAD_EXAM: 'Baixar laudo',
    SITE_MAP: {
      LUNG: 'Pulmão',
      PROSTATE: 'Prostata',
    },
    STARTED_GENERATING: 'Geração de laudo iniciada',
    GENERATION_FAILED: 'Falha ao gerar laudo',
    DOWNLOAD_FAILED: 'Falha no download',
    DOWNLOAD_NOW: 'Baixar relatório',
    TEMPLATES: 'Templates disponíveis',
    BEST_CANDIDATES: 'Melhores candidatos',
    LOADING_IMAGE: 'Carregando imagem',
  };

  static IA_TOOLS = {
    DETECT_CANCER_AREA: 'EXECUTAR',
    HEATMAP: 'Mapa de calor',
    HEATMAP_COLOR: 'Cor do mapa de calor',
    SELECT_MODEL: 'Selecione o modelo desejado',
    OPACITY: 'Opacidade',
    MIN_PERCENTAGE: 'Probabilidade mínima',
    RUN_MODEL: 'Executar modelo',
    DIAGNOSTIC: 'Diagnóstico',
    FAILED: 'Falha na execução',
    ALREADY_RUN:
      'Execução desse modelo já foi realizada. Delete para uma nova inferência',
    ON_QUEUE: 'Em fila de processamento',
  };

  static LOGIN = {
    TITLE: 'Login Oncodata',
    EMAIL: 'Email: ',
    PASSWORD: 'Senha: ',
    ERROR_REQUIRED: 'Campo obrigatorio',
    FORGOT_PASSWORD: 'Esqueci a senha',
    NO_ACCOUNT: 'Não possui conta?',
    REGISTER: 'Cadastre-se',
    SUBMIT: 'Log in',
    LOGIN_SUCCESSFULL: 'Login efetuado',
    LOGIN_FAILED: 'Credenciais incorretas',
    FORGOT_INSTRUCTIONS:
      'Insira seu email para receber instruções de como redefinir sua senha',
    FORGOT_SUCCESS: 'Email com instruções para redefinir sua senha enviado',
    FORGOT_ERROR: 'Erro ao redefinir sua senha',
    FORGOT_REMEMBER: 'Lembrou da sua senha?',
    FORGOT_BACK_TO_LOGIN: 'Faça login',
    FORGOT_BUTTON: 'Redefinir senha',
    NEW_PASSWORD_INSTRUCTIONS: 'Digite seu email e uma nova senha.',
    NEW_PASSWORD_SAVED:
      'Senha redefinida com sucesso! Você será direcionado para o login.',
    SHOW_PASSWORD: 'Mostrar senha',
  };

  static REGISTER = {
    TITLE: 'Cadastro Oncodata',
    NAME: 'Nome completo',
    TYPE_REGISTER: 'Tipo de cadastro',
    AVAILABLE_TYPES: [
      { label: 'Médico', value: 1 },
      { label: 'Administrativo', value: 2 },
      { label: 'Técnico', value: 3 },
    ],
    CRM: 'CRM',
    STATE: 'Estado',
    EMAIL: 'Endereço de email',
    PASSWORD: 'Digite sua senha',
    PASSWORD_CONFIRMATION: 'Confirme sua senha',
    SHOW_PASSWORD: 'Mostrar',
    HIDE_PASSWORD: 'Ocultar',
    SUBMIT: 'Registar',
    HAVE_ACCOUNT: 'Já possui conta?',
    BACK_TO_LOGIN: 'Faça login',
    ERROR_REQUIRED: 'Campo obrigatorio',
    ERROR_EMAIL: 'Email inválido',
    ERROR_MIN_LENGTH: 'Mínimo de 6 caracteres',
    ERROR_MAX_LENGTH: 'Máximo de 6 caracteres',
    FORM_INVALID: 'Formulário contém erros',
    BACKEND_ERROR: 'Erro no backend ',
    USER_CREATED: 'Usuario criado',
    PASSWORDS_NOT_EQUAL: 'Senhas não coincidem',
    TENANT: 'Laboratorio',
    STATES: [
      'AC',
      'AL',
      'AP',
      'AM',
      'BA',
      'CE',
      'DF',
      'ES',
      'GO',
      'MA',
      'MT',
      'MS',
      'MG',
      'PA',
      'PB',
      'PR',
      'PE',
      'PI',
      'RJ',
      'RN',
      'RS',
      'RO',
      'RR',
      'SC',
      'SP',
      'SE',
      'TO',
    ],
  };

  static REGISTER_EXAM = {
    TITLE: 'Cadastro de caso',
    PATIENT_SELECTION_LABEL: 'Nome do paciente',
    DOCTOR_SELECTION_LABEL: 'Nome do médico responsável',
    TISSUE_REGION_SELECTION_LABEL: 'Região do tecido',
    WAITING_SELECT: 'Selecione...',
    NO_PATIENTS: 'Nenhum paciente encontrado. Crie um novo',
    CREATE_PATIENT: 'Criar paciente',
    CANCEL: 'Cancelar',
    PATIENT_NAME: 'Nome:',
    PATIENT_GENDER: 'Sexo:',
    PATIENT_BIRTHDAY: 'Data de nascimento:',
    PATIENT_CATEGORY: 'Categoria:',
    PATIENT_ORIGIN: 'Procedencia:',
    PATIENT_PHONE: 'Telefone:',
    PATIENT_EMAIL: 'E-mail:',
    PATIENT_ADDRESS: 'Endereço:',
    EXAM_DESCRIPTION: 'Descrição do exame',
    EXAM_URGENCY: 'Urgência do caso',
    PRONTUARY: 'Anexo de Prontuário',
    IMAGES: 'Anexo de imagens',
    ADD_IMAGE: 'Adicione uma imagem',
    SUBMIT_EXAM: 'Salvar exame',
    GENDER_M: 'Masculino',
    GENDER_F: 'Feminino',
    URGENCY_YES: 'SIM',
    URGENCY_NO: 'NAO',
    ERROR_REQUIRED: 'Campo obrigatorio',
    SUCCESS: 'Exame criado com sucesso',
    ERROR_CREATING: 'Erro ao criar exame',
    CREATE_PATIENT_SUCCESS: 'Paciente criado com sucesso',
    CREATE_PATIENT_ERROR: 'Erro ao criar paciente',
    ERROR_MISSING_PATIENT:
      'Informações do paciente faltantes. Caso seja um paciente novo, use a opção "Criar paciente"',
    ERROR_MISSING_FIELDS: 'Preencha todos os campos',
    ERROR_MISSING_URGENCY: 'Selecione a urgencia',
    ERROR_MISSING_IMAGES: 'Selecione pelo menos uma imagem',
    ERROR_MISSING_TISSUE_REGION: 'Selecione a região do tecido',
    TISSUE_REGION_OPTIONS: [
      { label: 'Pulmão', value: 'LUNG' },
      { label: 'Próstata', value: 'PROSTATE' },
      { label: 'Linfonodo', value: 'LYMPHNODE' },
      { label: 'Outro', value: 'Outro' },
    ],
  };

  static UPLOAD_IMAGE = {
    UPLOAD: 'Adicionar nova imagem',
    NO_IMAGE: 'Nenhuma imagem adicionada',
    UPLOADING: 'Fazendo upload ...',
    ERROR_FAILED_UPLOAD: 'Problemas no upload. Cheque o arquivo fornecido',
  };

  static USER_MANAGEMENT = {
    PAGINATOR: 'Escolha a página',
    TITLE: 'Gerenciamento de usuários',
    USER_ID: 'ID',
    STATUS_UPDATED: 'Status atualizado',
    ERROR_UPDATING_STATUS: 'Erro ao atualizar status',
    ROLE_UPDATED: 'Função atualizada',
    ERROR_UPDATING_ROLE: 'Erro ao atualizar função',
    USER_NAME: 'Nome',
    USER_EMAIL: 'Email',
    USER_ROLE: 'Perfil',
    USER_CRM: 'CRM',
    USER_CRM_STATE: 'Estado',
    ACTIONS: 'Ações',
    EDIT_USER: 'Editar usuário',
    ACTIVATE_USER: 'Ativar usuário',
    INACTIVATE_USER: 'Inativar usuário',
    INVITE_USER: 'Convidar usuário',
    USER_UPDATED: 'Usuário atualizado',
    SEE_INACTIVE_USERS: 'Ver usuários inativos',
    SEE_ACTIVE_USERS: 'Ver usuários ativos',
    USER_INVITED: 'Usuário convidado',
    USER_TENANT: 'Laboratório',
    ERROR_UPDATING_PROFILE_PICTURE: 'Erro ao atualizar foto de perfil',
  };

  static EDIT_USER_DIALOG = {
    TITLE: 'Editar usuário',
    FULL_NAME: 'Nome completo',
    EMAIL: 'Email',
    CRM: 'CRM',
    CRM_STATE: 'Estado',
    ROLE: 'Perfil',
    SAVE: 'Salvar',
    CANCEL: 'Cancelar',
  };

  static INVITE_USER_DIALOG = {
    TITLE: 'Convidar usuário',
    FULL_NAME: 'Nome completo',
    EMAIL: 'Email',
    ROLE: 'Perfil',
    SAVE: 'Convidar',
    CANCEL: 'Cancelar',
    TENANT: 'Laboratório',
  };

  static ANNOTATION_CONTROL = {
    MEASUREMENT: 'Medida: ',
    UNITY: ' mm',
    AREA_UNITY: ' mm2',
    AREA: 'Área',
    DIMENSIONS: 'Dimensões',
    SUBMIT: 'salvar',
    NAME: 'Nome: ',
    DESCRIPTION: 'Descrição: ',
    MESSAGE_PLACEHOLDER: 'Adicionar mensagem',
    TITLE_PLACEHOLDER: 'Adicionar título',
    DESCRIPTION_PLACEHOLDER: 'Adicionar descrição',
    ANNOTATIONS_CREATED: 'Anotações criadas:',
    EXPORT_ANNOTATIONS: 'Exportar anotações',
    SEND: 'Enviar',
    SHARE_ANNOTATION: 'Anotação',
    ERROR_NO_MEASURE_ANNOTATIONS:
      'Apenas anotações livres são exportadas, ao contrário de medições. Atualmente não existem anotações livres',
    REVOKE_EXTERNAL_ACCESS: 'Revogar acesso pelo usuário externo',
    UNREVOKE_EXTERNAL_ACCESS: 'Restabelecer acesso pelo usuário externo',
    REVOKE_EXTERNAL_ACCESS_SUCCESS:
      'Acesso revogado. O usuário externo não poderá mais acessar a discussão.',
    UNREVOKE_EXTERNAL_ACCESS_SUCCESS:
      'Acesso restabelecido. O usuário externo poderá acessar a discussão.',
    SHOW_SHARE_LINK: 'Exibir link de compartilhamento com usuário externo',
    ANONYMOUS_USER: 'Anônimo',
    KI67: 'Ki67',
  };

  static SLIDE_CLASSIFICATOR = {
    METASTASIS: 'Metastase: ',
    TUMOR_SITE: 'Orgão proveniente: ',
    TUMOR_SUBTYPE: 'Subtipo de tumor: ',
    PRIMARY_SITE: 'Sítio primario: ',
    NON_APLICANT: 'Não se aplica',
    SITE_MAP: {
      LUNG: 'Pulmão',
      PROSTATE: 'Prostata',
    },
    SUBTYPE_MAP: {
      NON_APLICANT: 'Não se aplica',
      ADENO: 'Adenocarcinoma',
      CEC: 'Células escamosas',
      PEQ_CELLS: 'Pequenas células',
      MALIGN: 'Tumor maligno',
      NORMAL: 'Tecido normal',
    },
    METASTASIS_OPTIONS: [
      {
        title: 'SIM',
        value: true,
      },
      {
        title: 'NÃO',
        value: false,
      },
    ],
    NEEDS_UPDATE: 'Precisa de classifição',
    OK_DATA: 'Imagem classificada',
    BACKEND_ERROR: 'Erro no backend ',
    ERROR_REQUIRED: 'Campo obrigatorio',
    SUCCESS: 'Informações atualizadas com sucesso',
    SUBMIT: 'Atualizar',
    CLOSE: 'Fechar',
  };

  static IMAGE_FILTER = {
    TITLE: 'Banco de imagens',
    WAITING_SELECT: 'Selecione...',
    NO_RESULTS: 'Sem resultados',
    TUMOR_SITE: 'Local da lâmina',
    TUMOR_SUBTYPE: 'Subtipo de tumor',
    PRIMARY_SITE: 'Sítio primario',
  };

  static DISCUSSION_AREA = {
    CREATE_NEW: 'Adicionar discussão',
    ADD_EXTERNAL: 'Adicionar pessoa externa',
    SEARCH_PLACEHOLDER: 'Pesquisar...',
    EXTERNAL_NAME: 'Nome:',
    EXTERNAL_EMAIL: 'Email:',
    EXTERNAL_USER_CREATED_SUCCESSFULLY:
      'O usuário externo poderá acessar a discussão pela URL:',
    EXTERNAL_USER_CREATION_ERROR: 'Erro ao criar usuário externo.',
    EXTERNAL_USER_CREATION_ERROR_USER_ALREADY_EXISTS:
      'Erro ao criar usuário externo. O usuário escolhido já está disponível para ser convidado diretamente.',
    EXTERNAL_USER_CREATION_ERROR_INVALID_EMAIL: 'Email inválido.',
    COPY_SUCCESS: 'URL copiada com sucesso',
    EXTERNAL_USER_SUCCESS_TITLE: 'Compartilhamento externo',
    CLOSE_DIALOG: 'Fechar',
  };

  static PAGINATORS = {
    PAGINATOR: 'Escolha a página',
    NOIMAGE: 'Nenhuma imagem encontrada',
  };

  static EXAM_LIST = {
    SEARCH: 'Pesquisa',
    FILTERS: 'Filtros',
    WAITING_SELECT: 'Selecione...',
    NO_RESULTS: 'Sem resultados',
    NOEXAMREQUEST: 'Nenhum exame encontrado',
    DATE: 'Data',
    STATUS: 'Estado do caso',
    NO_MESSAGES: 'Nenhuma nova mensagem',
    STATUS_MAP: {
      NOT_STARTED: 'Não iniciado',
      STARTED: 'Em andamento',
      FINISHED: 'Finalizado',
    },
    EXAM_URGENCY: 'Urgência do caso',
    URGENCY_MAP: {
      true: 'Sim',
      false: 'Não',
    },
    PATIENT_NAME: 'Paciente',
    CODE: 'Código do exame',
    URGENCY: 'Urgência',
    NON_READS: 'Mensagens não lidas',
    FILTER_PATIENT: 'Paciente',
    FILTER_DOCTOR: 'Médico',
    ASSIGNED_TO: 'Médico responsável',
    CREATED_AT: 'Recebido em',
    FINISHED_AT: 'Liberado em',
    DATE_RANGE: 'Data de recebimento',
    DATE_RANGE_START: 'Data inicial',
    DATE_RANGE_END: 'Data final',
    FROM_LIS: 'Informações no LIS',
    DELETE: 'Deletar',
    EDIT_EXAM: 'Editar exame',
    DELETE_EXAM: 'Deletar exame',
    DELETE_EXAM_CONFIRMATION: 'Tem certeza que deseja deletar o exame?',
    DELETE_EXAM_CONFIRMATION_TEXT:
      'Esta ação não pode ser desfeita. O exame será perdido.',
    DELETE_EXAM_SUCCESS: 'Exame deletado com sucesso',
    DELETE_EXAM_ERROR: 'Erro ao deletar exame',
    DELETE_EXAM_CANCEL: 'Cancelar',
    DELETE_EXAM_CONFIRM: 'Deletar',
    ACTIONS: 'Ações',
    IMAGES: 'Imagens',
  };

  static GENERIC_COMPONENTS = {
    PLACEHOLDER_DROPDOWN: 'Selecione ou digite...',
    PLACEHOLDER_MULTIPLE_DROPDOWN: 'Selecione',
  };

  static EXAM_REDIRECT = {
    REDIRECTING: 'Redirecionando para exame',
    MISSING_CODE: 'Especifique o código do recurso desejado na url',
    NOT_FOUND: 'Recurso não encontrado',
    TRY_ANOTHER_VIEWER: 'Tente em outro visualizador',
    KFBIO: 'KFBIO',
    MOTIC: 'MOTIC',
  };

  static COLORMAP_CHOOSER = {
    CHOOSEN_COLOR: 'Cor do heatmap',
  };

  static ROLES = {
    ADMIN: 'Administrador',
    DOCTOR: 'Médico',
    TECHNICIAN: 'Técnico',
  };

  static INTEGRATION_LOG = {
    IMAGE_NAME: 'Nome da imagem',
    STATUS: 'Status',
    EXAM_CODE: 'Código do exame',
    LOG: 'Log',
    NODATA: 'Sem dados',
    CLOSE: 'Fechar',
    FAILED: 'Falhou',
    UNKNOWN_STATUS: 'Status desconhecido',
    SEARCH: 'Busca',
    RELOAD_LIST: 'Recarregar status',
    STATUS_LIST: [
      {
        class: 'on-queue',
        label: 'Na fila',
      },
      {
        class: 'saved-at-cache',
        label: 'Salvo no cache',
      },
      {
        class: 'removed-from-cache',
        label: 'Removido do cache',
      },
      {
        class: 'anonimized',
        label: 'Anonimizado',
      },
      {
        class: 'kfb-converted',
        label: 'KFB convertido',
      },
      {
        class: 'lis-recovered',
        label: 'Informação lis recuperada',
      },
      {
        class: 'saved-oncodata',
        label: 'Salvo na oncodata',
      },
      {
        class: 'upload-finished',
        label: 'Upload realizado',
      },
      {
        class: 'saved-successfully',
        label: 'Imagem cadastrada',
      },
    ],
    TYPE_RESOURCE: 'Digite o código do recurso',
    RESOURCE_NOT_FOUND: 'Recurso não encontrado',
    IMAGE_EXISTS: 'Imagem cadastrada',
    EXAM_EXISTS: 'Exame cadastrado',
    PRESENT_IMAGES: 'Imagens presentes',
    SAME_BLOCK_IMAGES: 'Imagens do mesmo bloco',
    SHOW_FULL_LOG: 'Exibir o log completo',
  };

  static USER_PROFILE_DIALOG = {
    FULL_NAME: 'Nome Completo',
    ROLE: 'Perfil',
    EDIT_PROFILE: 'Editar Perfil',
    LOGOUT: 'Deslogar',
    CROP_PROFILE_PICTURE: 'Recortar foto de perfil',
    CANCEL: 'Cancelar',
    SAVE: 'Salvar',
    ERROR_PROCESSING_PROFILE_PICTURE: 'Erro ao processar foto de perfil',
    PROFILE_PICTURE_UPDATED: 'Foto de perfil atualizada',
    ERROR_UPDATING_PROFILE_PICTURE: 'Erro ao atualizar foto de perfil',
  };

  static MODEL_LABELS = {
    LUNG: {
      name: 'Subtipo histológico - pulmão',
      classes: [
        'Sugestivo de adenocarcinoma',
        'Sugestivo de carcinoma de células escamosas',
        'Baixa suspeita de malignidade',
        'Sugestivo de carcinoma de pequenas células',
      ],
    },
    PROSTATE: {
      name: 'Detecção de tumor - prostata',
      classes: ['Baixa suspeita de malignidade', 'Suspeito para malignidade'],
    },
    LYMPHNODE: {
      name: 'Detecção metastase - Linfonodo',
      classes: [
        'Baixa suspeita de malignidade',
        'Regiões malignas identificadas',
      ],
    },
    URGENCY: {
      name: 'Modelo de urgenciamento',
      classes: ['Baixa suspeita de malignidade', 'Suspeito para malignidade'],
    },
    BREAST: {
      name: 'Detecção de tumor - mama',
      classes: ['Baixa suspeita de malignidade', 'Suspeito para malignidade'],
    },
  };

  static MONITORED_CASES = {
    ADD_EXAMS: 'Adicionar exames',
    CODE: 'Código',
    ADD: 'Adicionar',
    NOCASE: 'Sem casos monitorados',
    OPEN: 'Abrir',
    DELETE: 'Remover',
    SUCCESS_ADD: 'Caso adicionado com sucesso',
    SUCCESS_DELETE: 'Caso deletado com sucesso',
    FAILED_DELETE: 'Falha ao deletar caso ',
    DELETE_EXAM_CONFIRMATION: 'Tem certeza que deseja deletar o exame?',
    DELETE_EXAM_CONFIRMATION_TEXT:
      'Esta ação não pode ser desfeita. Será necessário cadastrar o exame novamente.',
    DELETE_EXAM_SUCCESS: 'Exame deletado com sucesso',
    DELETE_EXAM_ERROR: 'Erro ao deletar exame',
    DELETE_EXAM_CANCEL: 'Cancelar',
    DELETE_EXAM_CONFIRM: 'Deletar',
  };

  static SLIDE_LIST = {
    NUM_IMAGES: 'Imagens disponíveis: ',
    SAME_BLOCK_IMAGES: 'Imagens do mesmo bloco',
  };

  static PING_STATUS = {
    ONLINE: 'Laboratório online',
    OFFLINE: 'Laboratório offline',
  };

  static KI67_CONTROL = {
    MIN_DISTANCE: 'Distância minima',
    INTENSITY: 'Intensidade',
    SIZE: 'Tamanho',
    EFFECT_IN_THE_NEXT_RUN: '*Efeito na próxima execução',
  };
}
/*
export class Labels {
  static PATIENT_CARD = {
    NAME: 'Name: ',
    CODE: 'Code: ',
    URGENT: 'Urgent',
    NOT_STARTED: { key: 'NOT_STARTED', label: 'Not started' },
    STARTED: { key: 'STARTED', label: 'In progress' },
    FINISHED: { key: 'FINISHED', label: 'Finished' },
    EXTERNAL_PATIENT_DATA: '<Data from LIS>',
  };

  static BUG_REPORT = {
    TITLE: 'Reporta an error or send feedback',
    DESCRIPTION: 'Describe the error or feedback',
    SUBMIT: 'Send',
    WHERE_ERROR: 'Where did the error happen?',
    IA: 'AI',
    PLATFORM: 'Platform',
    OTHER: 'Other',
    ANALYSIS: 'Analysis',
    HEATMAP: 'Heatmap',
    DIGITAL_MICROSCOPE: 'Digital microscope',
    REPORT: 'Report',
    DISCUSSION: 'Discussion',
    DIGITAL_DATABASE: 'Image database',
    INCORRECT_RESULT: 'Incorrect result',
    EXECUTION: 'Execution',
    ERROR_DESCRIPTION_REQUIRED: 'The error description is mandatory',
    CANCEL: 'Cancel',
    SUCCESS: 'Error or feedback reported',
    ERROR: 'Failed to report error or feedback',
  };

  static INITIAL_TOOL_PANEL = {
    MY_EXAMS: 'My exams',
    DISCUSSIONS: 'New messages',
    DATABASE: 'Image database',
    REGISTER_CASE: 'Register case',
    USER_MANAGEMENT: 'User management',
    INTEGRATION_LOG: 'Integration Log',
    MONITOR_EXAMS: 'Monitor cases',
  };

  static CONTROLS = {
    SHARE_IMAGE: 'Share image',
    UNSHARE_IMAGE: 'Cancel sharing',
    ADD_TO_DATABASE: 'Add to image database',
    SPLIT: 'Split screen',
    CLOSE_SPLIT: 'Close',
    DRAG_IMAGE: 'Drag the desired image',
    IMAGE_MANIPULATION: 'Manipulate image',
    ZOOMIN: 'Zoom in',
    ZOOMOUT: 'Zoom out',
    MENU: 'Menu',
    RESTORE: 'Restore zoom',
    FULLSCREEN: 'Full screen',
    EXIT_FULLSCREEN: 'Exit fullscreen',
    SEPARATE_WINDOW: 'Open as a separate window',
    PAN: 'Pan',
    DRAW: 'Draw',
    DRAW_SQUARE: 'Draw square',
    PHOTO: 'Take picture',
    MEASURE: 'Measure',
    REVERT: 'Revert',
    FOV: 'FOV',
    INSERT_DESIRED_AREA: 'Insert the desired area in mm2',
    DISABLE_FOV: 'Disable FOV',
    CHOOSECOLOR: 'Choose color',
    FORWARD: 'Next exam',
    BACK: 'Previous exam',
    EXAMS: 'Exams',
    LIST: 'List',
    SHARE_IMAGE_SUCCESS_TITLE: 'The image was shared successfully',
    SHARE_IMAGE_SUCCESS_TEXT: 'Use the following url to share the image',
    UNSHARE_IMAGE_SUCCESS_TITLE: 'Sharing cancelled',
    ACTIVE: 'Active',
    COUNT: 'Count',
    TURN_VISIBLE: 'Turn visible',
    TURN_INVISIBLE: 'Turn invisible',
    DELETE: 'Delete',
    INSERT_NAME: 'Insert a name',
    REMOVE: 'Remove',
    ADD_COUNTING: 'Add counting',
    COUNTING: 'Manual counting',
    CLEAR_COUNTING: 'Clear counting',
    ROTATION: 'Rotation',
    BRIGHTNESS: 'Brightness',
    CONTRAST: 'Contrast',
    GAMMA: 'Gamma',
    RESET: 'Reset',
  };

  static DASHBOARD = {
    USE_LANDSCAPE: 'Please use in landscape mode',
    FULL_SCREEN_MODE: 'Use the full screen mode',
    EXAM_NOT_ALLOWED: 'Acess to the exam not allowed',
  };

  static DASHBOARD_TOOL_PANEL = {
    PRONTUARY: 'Prontuaru',
    IA: 'AI',
    REPORT: 'Report',
    DISCUSSION: 'Discussion',
    ANNOTATION: 'Annotations',
    SHOW_TOOLS: 'Tools',
    HIDE_TOOLS: 'Hide',
  };

  static EXAM_INFO = {
    CASE_ID: 'Case ID',
    REGION: 'Analysis region',
    PATIENT_CODE: 'Code',
    PATIENT_SEX: 'Gender',
    PATIENT_NAME: 'Name',
    PATIENT_AGE: 'Age',
    PATIENT_BIRTHDAY: 'Birthday',
    REGION_NAMES: {
      lung: 'Lung',
      prostate: 'Prostate',
      unknown: 'Not specified',
    },
  };

  static VIEWER = {
    SLIDELIST_TITLE: 'Slides',
    HEATMAP: 'Heatmap',
    DETECT_TUMOR: 'Detect tumor',
    SLIDES: 'Slides',
    TOOLS: 'Tools',
    LOADING_IMAGE: 'Loading image...',
    LOADING_MAP: 'Loading map...',
    ERROR_FETCHING_MAP: 'Error loading map',
    ERROR_FETCHING_IMAGE: 'Errorr loading image',
    CLOSE: 'Close',
    INFO: 'Informations',
    END_OF_LIST: 'Reached the end of the list',
    BEGIN_OF_LIST: 'Reached the beginning of the list',
  };

  static REPORT_TOOLS = {
    CAPTURE: 'Captire',
    LOAD: 'Templates',
    SELECT_TEMPLATE: 'Available templates',
    REPORT_PLACEHOLDER: 'Type here...',
    SAVE: 'Salve',
    SUCCESS: 'Report saved',
    SUCCESS_RELEASE: 'Report released',
    SUCCESS_REOPEN: 'Report reopened',
    RELEASE_EXAM: 'Release exam',
    REOPEN_EXAM: 'Reopen exam',
    GENERATE_PDF: 'Generate pdf',
    DOWNLOAD_EXAM: 'Download exam',
    SITE_MAP: {
      LUNG: 'Lung',
      PROSTATE: 'Prostate',
    },
    STARTED_GENERATING: 'Report generation started',
    GENERATION_FAILED: 'Failed to generate report',
    DOWNLOAD_FAILED: 'Failed to download',
    DOWNLOAD_NOW: 'Download report',
    TEMPLATES: 'Available Templates',
    BEST_CANDIDATES: 'Best candidates',
    LOADING_IMAGE: 'Loading image',
  };

  static IA_TOOLS = {
    DETECT_CANCER_AREA: 'RUN',
    HEATMAP: 'Toggle heatmap',
    HEATMAP_COLOR: 'Heatmap color',
    SELECT_MODEL: 'Select the desired model',
    MODEL_NAME_MAP: {
      LUNG: 'Histologic subtype - lung',
      PROSTATE: 'Tumor detection - prostate',
    },
    OPACITY: 'Opacity',
    MIN_PERCENTAGE: 'Minimum certain level',
    RUN_MODEL: 'Run model',
    DIAGNOSTIC: 'Diagnostic',
    FAILED: 'Execution failed',
    ALREADY_RUN:
      'This model was already run. Delete the inference to run anoter',
    ON_QUEUE: 'Waiting at the processing queue',
  };

  static LOGIN = {
    TITLE: 'Oncodata Login',
    EMAIL: 'Email: ',
    PASSWORD: 'Password: ',
    ERROR_REQUIRED: 'Required field',
    FORGOT_PASSWORD: 'Forgot password',
    NO_ACCOUNT: "Don't have an account?",
    REGISTER: 'Register',
    SUBMIT: 'Log in',
    LOGIN_SUCCESSFULL: 'Login successfull',
    LOGIN_FAILED: 'Wrong credentials',
    FORGOT_INSTRUCTIONS:
      'Insert your email to receive instrunctions on how to redefine your password',
    FORGOT_SUCCESS: 'Email sent',
    FORGOT_ERROR: 'Error redefining password',
    FORGOT_REMEMBER: 'Remembered the password?',
    FORGOT_BACK_TO_LOGIN: 'Login',
    FORGOT_BUTTON: 'Forgot my password',
    NEW_PASSWORD_INSTRUCTIONS: 'Insert your email and a new password',
    NEW_PASSWORD_SAVED: 'The password was redefined successfully',
    SHOW_PASSWORD: 'Show password',
  };

  static REGISTER = {
    TITLE: 'Oncodata Register',
    NAME: 'Full name',
    TYPE_REGISTER: 'Register type',
    AVAILABLE_TYPES: [
      { label: 'Doctor', value: 1 },
      { label: 'Admin', value: 2 },
      { label: 'Technician', value: 3 },
    ],
    CRM: 'CRM',
    STATE: 'State',
    EMAIL: 'Email address',
    PASSWORD: 'Enter the password',
    PASSWORD_CONFIRMATION: 'Confirm your password',
    SHOW_PASSWORD: 'Show',
    HIDE_PASSWORD: 'Hide',
    SUBMIT: 'Register',
    HAVE_ACCOUNT: 'Already have an account?',
    BACK_TO_LOGIN: 'Login',
    ERROR_REQUIRED: 'Required field',
    ERROR_EMAIL: 'Invalid email',
    ERROR_MIN_LENGTH: 'Minimun of 6 chars',
    ERROR_MAX_LENGTH: 'Minimum od 6 chars',
    FORM_INVALID: 'Form contain errors',
    BACKEND_ERROR: 'Backend error ',
    USER_CREATED: 'User created',
    PASSWORDS_NOT_EQUAL: 'Passwords are not equal',
    TENANT: 'Laboratory',
    STATES: [
      'AC',
      'AL',
      'AP',
      'AM',
      'BA',
      'CE',
      'DF',
      'ES',
      'GO',
      'MA',
      'MT',
      'MS',
      'MG',
      'PA',
      'PB',
      'PR',
      'PE',
      'PI',
      'RJ',
      'RN',
      'RS',
      'RO',
      'RR',
      'SC',
      'SP',
      'SE',
      'TO',
    ],
  };

  static REGISTER_EXAM = {
    TITLE: 'Register clinical case',
    PATIENT_SELECTION_LABEL: 'Patient name',
    DOCTOR_SELECTION_LABEL: 'Name of the assigned doctor',
    TISSUE_REGION_SELECTION_LABEL: 'Tissue region',
    WAITING_SELECT: 'Select...',
    NO_PATIENTS: 'No patient found. Please create a new one...',
    CREATE_PATIENT: 'Create patient',
    CANCEL: 'Cancel',
    PATIENT_NAME: 'Name:',
    PATIENT_GENDER: 'Sex:',
    PATIENT_BIRTHDAY: 'Birthday:',
    PATIENT_CATEGORY: 'Category:',
    PATIENT_ORIGIN: 'Origin:',
    PATIENT_PHONE: 'Phone:',
    PATIENT_EMAIL: 'E-mail:',
    PATIENT_ADDRESS: 'Address:',
    EXAM_DESCRIPTION: 'Exam description',
    EXAM_URGENCY: 'Case urgency',
    PRONTUARY: 'Prontuary attached',
    IMAGES: 'Images attached',
    ADD_IMAGE: 'Add an image',
    SUBMIT_EXAM: 'Save exam',
    GENDER_M: 'Male',
    GENDER_F: 'Female',
    URGENCY_YES: 'YES',
    URGENCY_NO: 'NO',
    ERROR_REQUIRED: 'Required field',
    SUCCESS: 'Exam created successfully',
    ERROR_CREATING: 'Error creating exam',
    CREATE_PATIENT_SUCCESS: 'Pacient created successfully',
    CREATE_PATIENT_ERROR: 'Error creating patient',
    ERROR_MISSING_PATIENT:
      'Patient information missing. In case of a new patient, use the option "Create patient"',
    ERROR_MISSING_FIELDS: 'Fill all the required fields',
    ERROR_MISSING_IMAGES: 'Select at least one image',
    ERROR_MISSING_TISSUE_REGION: 'Select tissue region',
    ERROR_MISSING_URGENCY: 'Select the urgency',
    TISSUE_REGION_OPTIONS: [
      { label: 'Lung', value: 'LUNG' },
      { label: 'Prostate', value: 'PROSTATE' },
      { label: 'Other', value: 'Outro' },
    ],
  };

  static UPLOAD_IMAGE = {
    UPLOAD: 'Add a new image',
    NO_IMAGE: 'No image added',
    UPLOADING: 'Uploading ...',
    ERROR_FAILED_UPLOAD: 'Upload problemas. Check the file type',
  };

  static USER_MANAGEMENT = {
    PAGINATOR: 'Choose a page',
    TITLE: 'User management',
    USER_ID: 'ID',
    STATUS_UPDATED: 'Updated status',
    ERROR_UPDATING_STATUS: 'Error updating status',
    ROLE_UPDATED: 'Role updated',
    ERROR_UPDATING_ROLE: 'Error updating role',
    USER_NAME: 'Name',
    USER_EMAIL: 'Email',
    USER_ROLE: 'Role',
    USER_CRM: 'CRM',
    USER_CRM_STATE: 'State',
    ACTIONS: 'Actions',
    EDIT_USER: 'Edit user',
    ACTIVATE_USER: 'Activate user',
    INACTIVATE_USER: 'Deactivate user',
    INVITE_USER: 'Invite user',
    USER_UPDATED: 'User invited',
    SEE_INACTIVE_USERS: 'See deactivated users',
    SEE_ACTIVE_USERS: 'See active users',
    USER_INVITED: 'Invited user successfully',
    USER_TENANT: 'Laboratory',
  };

  static EDIT_USER_DIALOG = {
    TITLE: 'Edit user',
    FULL_NAME: 'Full name',
    EMAIL: 'Email',
    CRM: 'CRM',
    CRM_STATE: 'State',
    ROLE: 'Role',
    SAVE: 'Salve',
    CANCEL: 'Cancel',
  };

  static INVITE_USER_DIALOG = {
    TITLE: 'Invite user',
    FULL_NAME: 'Full name',
    EMAIL: 'Email',
    ROLE: 'Role',
    SAVE: 'Invite',
    CANCEL: 'Cancel',
    TENANT: 'Laboratory',
  };

  static ANNOTATION_CONTROL = {
    MEASUREMENT: 'Measurement: ',
    UNITY: ' mm',
    AREA_UNITY: ' mm2',
    AREA: 'Area',
    DIMENSIONS: 'Dimensions',
    SUBMIT: 'Save',
    NAME: 'Name: ',
    DESCRIPTION: 'Description: ',
    TITLE_PLACEHOLDER: 'Add title',
    DESCRIPTION_PLACEHOLDER: 'Add description',
    MESSAGE_PLACEHOLDER: 'Add message',
    ANNOTATIONS_CREATED: 'Created annotations:',
    EXPORT_ANNOTATIONS: 'Export annotations',
    SEND: 'Send',
    SHARE_ANNOTATION: 'Annotation',
    ERROR_NO_MEASURE_ANNOTATIONS:
      'Only free annotations are expored, measurements are not. Currently there are no free annotations',
    REVOKE_EXTERNAL_ACCESS: 'Revoke external access',
    UNREVOKE_EXTERNAL_ACCESS: 'Unrevoke external access',
    REVOKE_EXTERNAL_ACCESS_SUCCESS:
      'Access revoked. The external user can`t access the discussion anymore.',
    UNREVOKE_EXTERNAL_ACCESS_SUCCESS:
      'Acess granted. The external user will have access to the discussion.',
    SHOW_SHARE_LINK: 'Show sharing link',
    KI67: 'Ki67',
  };

  static SLIDE_CLASSIFICATOR = {
    METASTASIS: 'Metastasis: ',
    TUMOR_SITE: 'Tumor site: ',
    TUMOR_SUBTYPE: 'Tumor subtype: ',
    PRIMARY_SITE: 'Primary site: ',
    NON_APLICANT: 'Non aplicant',
    SITE_MAP: {
      LUNG: 'Lung',
      PROSTATE: 'Prostate',
    },
    SUBTYPE_MAP: {
      NON_APLICANT: 'Non applicant',
      ADENO: 'Adenocarcinoma',
      CEC: 'Scamous cells carcinoma',
      PEQ_CELLS: 'Small cells carcinoma',
      MALIGN: 'Malignant tumor',
      NORMAL: 'Normal tissue',
    },
    METASTASIS_OPTIONS: [
      {
        title: 'YES',
        value: true,
      },
      {
        title: 'NO',
        value: false,
      },
    ],
    NEEDS_UPDATE: 'Precisa de classifição',
    OK_DATA: 'Image classified',
    BACKEND_ERROR: 'Backend error ',
    ERROR_REQUIRED: 'Required field',
    SUCCESS: 'Info updated successfully',
    SUBMIT: 'Update',
    CLOSE: 'Close',
  };

  static IMAGE_FILTER = {
    TITLE: 'Image database',
    WAITING_SELECT: 'Select...',
    NO_RESULTS: 'No results',
    TUMOR_SITE: 'Tumor site',
    TUMOR_SUBTYPE: 'Tumor subtype',
    PRIMARY_SITE: 'Primary site',
  };

  static DISCUSSION_AREA = {
    CREATE_NEW: 'Add discussion',
    ADD_EXTERNAL: 'Add external user',
    SEARCH_PLACEHOLDER: 'Search...',
    EXTERNAL_NAME: 'Name:',
    EXTERNAL_EMAIL: 'Email:',
    EXTERNAL_USER_CREATED_SUCCESSFULLY:
      'The external user has now access to the discussion.',
    EXTERNAL_USER_CREATION_ERROR: 'Error creating external user.',
    EXTERNAL_USER_CREATION_ERROR_USER_ALREADY_EXISTS:
      'Error creating external user. The choosen user is already available to be directely invited.',
    EXTERNAL_USER_CREATION_ERROR_INVALID_EMAIL: 'Invalid email.',
    COPY_SUCCESS: 'URL copied successfully',
    EXTERNAL_USER_SUCCESS_TITLE: 'External sharing',
    CLOSE_DIALOG: 'Close',
  };

  static PAGINATORS = {
    PAGINATOR: 'Choose a page',
    NOIMAGE: 'No image found',
  };

  static EXAM_LIST = {
    SEARCH: 'Search',
    FILTERS: 'Filters',
    WAITING_SELECT: 'Select...',
    NO_RESULTS: 'No results',
    NOEXAMREQUEST: 'No exam found',
    DATE: 'Date',
    STATUS: 'Exam state',
    NO_MESSAGES: 'No new messages',
    STATUS_MAP: {
      NOT_STARTED: 'Not started',
      STARTED: 'In progress',
      FINISHED: 'Finished',
    },
    EXAM_URGENCY: 'Case urgency',
    URGENCY_MAP: {
      true: 'Yes',
      false: 'No',
    },
    PATIENT_NAME: 'Pacient name',
    CODE: 'Patient code',
    URGENCY: 'Urgency',
    NON_READS: 'Non read messages',
    FILTER_PATIENT: 'Pacient',
    FILTER_DOCTOR: 'Doctor',
    ASSIGNED_TO: 'Assigned doctor',
    CREATED_AT: 'Received date',
    FINISHED_AT: 'Released date',
    DATE_RANGE: 'Range for received date',
    DATE_RANGE_START: 'Start date',
    DATE_RANGE_END: 'End date',
    ACTIONS: 'Actions',
    EDIT_EXAM: 'Edit exam',
    FROM_LIS: 'Information at LIS',
    EDIT: 'Edit',
    DELETE_EXAM: 'Delete exame',
    DELETE_EXAM_CONFIRMATION: 'Are you sure you want to delete the exam?',
    DELETE_EXAM_CONFIRMATION_TEXT:
      'This action cant be undone. The exam will be lost.',
    DELETE_EXAM_SUCCESS: 'Exam delete successfully',
    DELETE_EXAM_ERROR: 'Error deleting exam',
    DELETE_EXAM_CANCEL: 'Cancel',
    DELETE_EXAM_CONFIRM: 'Delete',
    IMAGES: 'Images',
  };

  static GENERIC_COMPONENTS = {
    PLACEHOLDER_DROPDOWN: 'Select or type...',
    PLACEHOLDER_MULTIPLE_DROPDOWN: 'Select',
  };

  static EXAM_REDIRECT = {
    REDIRECTING: 'Redirecting to exam....',
    MISSING_CODE: 'Especify the exam code at the url',
    NOT_FOUND: 'Not found',
    TRY_ANOTHER_VIEWER: 'Try another viewer',
    KFBIO: 'KFBIO',
    MOTIC: 'MOTIC',
  };

  static COLORMAP_CHOOSER = {
    CHOOSEN_COLOR: 'Heatmap color',
  };

  static ROLES = {
    ADMIN: 'Admin',
    DOCTOR: 'Doctor',
    TECHNICIAN: 'Technician',
  };

  static INTEGRATION_LOG = {
    IMAGE_NAME: 'Image name',
    STATUS: 'Status',
    EXAM_CODE: 'Exam code',
    LOG: 'Log',
    NODATA: 'No data',
    CLOSE: 'Close',
    FAILED: 'Failed',
    UNKNOWN_STATUS: 'Unknown state',
    SEARCH: 'Search',
    RELOAD_LIST: 'Reload status',
    STATUS_LIST: [
      {
        class: 'on-queue',
        label: 'On queue',
      },
      {
        class: 'saved-at-cache',
        label: 'Saved at cache',
      },
      {
        class: 'removed-from-cache',
        label: 'Removed from cache',
      },
      {
        class: 'anonimized',
        label: 'Anonimized',
      },
      {
        class: 'kfb-converted',
        label: 'KFB converted',
      },
      {
        class: 'lis-recovered',
        label: 'Lis information recovered',
      },
      {
        class: 'saved-oncodata',
        label: 'Saved at Oncodata',
      },
      {
        class: 'upload-finished',
        label: 'Upload finished',
      },
      {
        class: 'saved-successfully',
        label: 'Image fully saved',
      },
    ],
    TYPE_RESOURCE: 'Type the resource code',
    RESOURCE_NOT_FOUND: 'Resource not found',
    IMAGE_EXISTS: 'Image is in our platform',
    EXAM_EXISTS: 'Exam is in our platform',
    PRESENT_IMAGES: 'Present images',
    SAME_BLOCK_IMAGES: 'Same block image',
    SHOW_FULL_LOG: 'Show complete log',
  };

  static USER_PROFILE_DIALOG = {
    FULL_NAME: 'Full name',
    ROLE: 'Role',
    EDIT_PROFILE: 'Edit role',
    LOGOUT: 'Logout',
    CROP_PROFILE_PICTURE: 'Cut the profile picture',
    CANCEL: 'Cancel',
    SAVE: 'Salve',
    ERROR_PROCESSING_PROFILE_PICTURE: 'Error to process the profile pricture',
    PROFILE_PICTURE_UPDATED: 'Profile picture updated',
    ERROR_UPDATING_PROFILE_PICTURE: 'Error updating profile picture',
  };

  static MODEL_LABELS = {
    LUNG: {
      name: 'Lung histologic subtype',
      classes: [
        'Suggestive of adenocarcinoma',
        'Suggestive of scamous cells carcinoma',
        'Low suspicion of malignancy',
        'Suggestive of small cells carcinoma',
      ],
    },
    PROSTATE: {
      name: 'Prostate tumor detection',
      classes: ['Low suspicion of malignancy', 'Malignant tissue'],
    },
    LYMPHNODE: {
      name: 'Lymphnode tumor detection',
      classes: ['Low suspicion of malignancy', 'Malignant regions identified'],
    },
    URGENCY: {
      name: 'Urgency classification model',
      classes: ['Low suspicion of malignancy', 'Malignant tissue'],
    },
    BREAST: {
      name: 'Tumor detection - breast',
      classes: ['Low suspicion of malignancy', 'Malignant tissue'],
    },
  };

  static MONITORED_CASES = {
    ADD_EXAMS: 'Add exams',
    CODE: 'Code',
    ADD: 'Add',
    NOCASE: 'No monitored cases',
    OPEN: 'Open',
    DELETE: 'Delete',
    SUCCESS_ADD: 'Case added successfully',
    SUCCESS_DELETE: 'Case deleted successfully',
    FAILED_DELETE: 'Failed to delete case ',
    DELETE_EXAM_CONFIRMATION: 'Are you sure you want to delete this exam?',
    DELETE_EXAM_CONFIRMATION_TEXT:
      'This action cant be undone. It will be necessary to register the exam again.',
    DELETE_EXAM_SUCCESS: 'Exam deleted successfully',
    DELETE_EXAM_ERROR: 'Error deleting exam',
    DELETE_EXAM_CANCEL: 'Cancel',
    DELETE_EXAM_CONFIRM: 'Delete',
  };

  static SLIDE_LIST = {
    NUM_IMAGES: 'Available images: ',
    SAME_BLOCK_IMAGES: 'Images from the same block',
  };

  static PING_STATUS = {
    ONLINE: 'Lab online',
    OFFLINE: 'Lab offline'
  };

  static KI67_CONTROL = {
    MIN_DISTANCE: 'Minimum Distance',
    INTENSITY: 'Intensity',
    SIZE: 'Size',
    EFFECT_IN_THE_NEXT_RUN: '*Will take effect on the next run',
  };
}
*/
